/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Text
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../utils/helpers';

const PerformanceBySKUChart = ({
  dir, dateWiseData, height, 
  index,type
}) => {
  const { t } = useTranslation('common');

  const [color1, color2, color3] = colorsCombination[index % 10];
  const values = dateWiseData.map(item => parseFloat(item.value));
  let maxValue = Math.max(...values);
  maxValue = maxValue < 1 ? maxValue + 0.1 : maxValue + 1

  const handleChartType = (value, column) => {
    let chartType = '';
    if (column === 'conversions' || column === 'unitSessionPercentage' 
    || column === 'ppcSalesPercentage' || column === 'ppcConversion' || 
    column === 'acos' || column === 'tacosPercentage' || column === 'marginPercentage') {
      chartType = `${setCurrencyFormat(value, false)}%`
    }
    else if (column === 'salesAmount' || column === 'profit' ||
    column === 'ppcSales' || column === 'ppcCost' || column === 'ppcCostPerClick'
    || column === 'ppcCostPerOrder') {
      chartType = `${setCurrencyFormat(value, true)}`
    }
    else {
      chartType = `${setCurrencyFormat(value, false)}`
    }
    return chartType;
  }

  console.log(type)

  return (
    <>
      {/* <div className="card__title">
        <h5 className="bold-text">{t('comparemonthlysales.compareMonth')}</h5>
      </div> */}
      <div dir="ltr">
        <ResponsiveContainer height={height}>
          <LineChart
            data={dateWiseData}
            margin={{
              top: 0, right: 0, left: 25, bottom: 0,
            }}
          >
            <XAxis dataKey="date" reversed={dir === 'rtl'} />
            <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
              tickFormatter={value => handleChartType(value, type)}
              width={90}
              allowDataOverflow
              domain={[0, maxValue]}
            />
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <Tooltip formatter={value => handleChartType(value, type)} />
            <Legend />
            <Line dot={false} type="monotone" dataKey="value" stroke={color1 || '#3366ff'} strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

PerformanceBySKUChart.propTypes = {
  dir: PropTypes.string.isRequired,  
  dateWiseData: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  index: PropTypes.number,
  type: PropTypes.string.isRequired
};

PerformanceBySKUChart.defaultProps = {  
  index: 0
}

export default PerformanceBySKUChart;
